import { schema } from 'normalizr';

export const StepChildSchema = new schema.Entity('stepChildren');
